import Reveal from "@/components/base/Reveal";
import { sobrePositioning } from "@/mocks/sobre";

export default function SobrePositioning() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-secondary-700">
              <i className="ri-compass-3-line" aria-hidden="true"></i>
              Posicionamento
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Uma estrutura digital feita para empresas.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Mais do que hospedar, ajudamos empresas a construir uma presença digital sólida e
              preparada para crescer.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {sobrePositioning.map((item, index) => (
            <Reveal key={item.title} delay={index * 80} className="h-full">
              <article className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {item.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}